import React from 'react'
import { useExercise } from '../ExerciseProvider'
import { DecisionMakingProvider } from './DecisionMakingProvider'
import PartOne from './PartOne'
import PartTwo from './PartTwo'
import PartThree from './PartThree'
import PartFour from './PartFour'

const DecisionMakingExerciseInner = () => {
  const { exerciseIndex } = useExercise()

  return (
    <div>
      {exerciseIndex === 0 && <PartOne />}
      {exerciseIndex === 1 && <PartTwo />}
      {exerciseIndex === 2 && <PartThree />}
      {exerciseIndex === 3 && <PartFour />}
    </div>
  )
}

const DecisionMakingExercise = ({ ...props }) => {
  return (
    <DecisionMakingProvider {...props}>
      <DecisionMakingExerciseInner />
    </DecisionMakingProvider>
  )
}

export default DecisionMakingExercise
